import { useEffect } from "react";
import { FC } from "react";
import { Grid } from "@mui/material";
import {
  Navigate,
  Route,
  Routes,
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { AdRoutes } from "../../constants/ad-routes";
import LoginPage from "./login-page";
import { makeSxStyles } from "ui";
import ForgotPasswordPage from "./forgot-password-page";
import ForgotPasswordCompletePage from "./forgot-password-complete-page";
import AcceptInvitePage from "./accept-invite-page";

export enum AllowedRedirectsEnum {
  resetPassword = "resetPassword",
  registerAdmin = "registerAdmin",
}

const redirectToMap: Record<AllowedRedirectsEnum, AdRoutes> = {
  [AllowedRedirectsEnum.resetPassword]: AdRoutes.forgotPasswordComplete,
  [AllowedRedirectsEnum.registerAdmin]: AdRoutes.acceptInvite,
};

const AuthRouter: FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirectTo = searchParams.get("redirectTo") as AllowedRedirectsEnum;
    if (redirectTo && redirectToMap[redirectTo]) {
      searchParams.delete("redirectTo");

      return navigate({
        pathname: redirectToMap[redirectTo],
        search: createSearchParams(searchParams).toString(),
      });
    }
  }, []);

  return (
    <Grid sx={styles.container}>
      <Routes>
        <Route path={AdRoutes.login} element={<LoginPage />} />
        <Route
          path={AdRoutes.forgotPasswordComplete}
          element={<ForgotPasswordCompletePage />}
        />
        <Route
          path={AdRoutes.forgotPassword}
          element={<ForgotPasswordPage />}
        />
        <Route path={AdRoutes.acceptInvite} element={<AcceptInvitePage />} />
        <Route path="*" element={<Navigate to={AdRoutes.login} />} />
      </Routes>
    </Grid>
  );
};

const useStyles = makeSxStyles(() => ({
  container: {
    width: "100wv",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    background:
      "radial-gradient( ellipse farthest-corner at top right, rgba(0, 128, 184, 0.30) 10%, rgba(138, 206, 255, 0) 80%)",
    filter: "grayscale(30%)",
  },
}));

export default AuthRouter;
